// Korean

const lang = {
  gateMediaPreviewHeader: '귀하를 위한 추천 항목',
  loadmore: '더 보기',
  nextMedia: '다음 미디어',
  previousMedia: '이전 미디어',
  closePost: '포스트 닫기',
  nextPost: '다음 포스트',
  previousPost: '이전 포스트',
  outOfStock: '품절',
  numberOfReviews() {
    return '개의 리뷰'
  },
  reportFormField: '메시지를 입력하십시오',
  reportPost: '포스트 신고',
  reportFormTitle: '이 이미지를 보고하시겠습니까?',
  reportFormDetails:
    '이 이미지가 적절하지 않거나 불법, 또는 타인의 권리를 침해하는 경우 해당 콘텐츠를 보고하실 수 있습니다. 이 이미지/텍스트를 보고하는 경우, 콘텐츠 관리자에게 통보되며 적절한 조치를 취하게 됩니다.',
  reportFormMessagePlaceholder: '보고 원인을 입력하십시오',
  reportFormMessageLabel: '메시지',
  reportFormEmailLabel: '내 이메일',
  reportFormSubmitButtonText: '보고서 보내기',
  reportFormCancelButtonText: '취소',
  reportFormSentTitle: '보고해주셔서 감사합니다',
  reportFormSentCloseButtonText: '닫기',
  cardAndTileAriaLabel: '아래는 다양한 소셜 미디어 플랫폼 계정의 게시물 목록입니다.',
  carouselAriaLabel: '아래는 다양한 소셜 미디어 계정의 포스트를 포함한 캐러셀입니다.',
  singleAriaLabel: '아래는 한 SNS 계정의 글이다.',
  poweredBy: 'Flowbox 제공',
  postAltText: (userName, date) => {
    const publishedString = date && !userName ? `${date} 에 게시된 사진` : ''
    const createdByString = userName && !date ? `${userName} 님의 사진` : ''
    const fullString = date && userName ? `${userName} 님이 ${date} 에 게시한 사진` : ''
    const photo = !date && !userName ? '사진' : ''
    return `${fullString}${photo}${createdByString}${publishedString}`
  },
  uploadYourMedia: '미디어 업로드',
  openTheGate: '대화 상자 열기',
}

export default lang
